import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "pv-title",
	templateUrl: "./title.component.html",
	styleUrls: ["./title.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleComponent {}
